module.exports = __webpack_public_path__ + "img/traffic-top-img.77444b81.png";